var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"register-wrap"},[_c('v-container',{staticClass:"register-page px-0 align-center justify-center"},[_c('v-slide-x-transition',{attrs:{"hide-on-leave":true}},[_c('RegisterAdminCard')],1)],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }